import { useAxiosPrivate } from "./axios";
import { Buffer } from "buffer";

const fileDownload = require("js-file-download");

const LIST_QUERY = "/email/list";
const GET_ATTACHMENT = "/email/attachment";

export const useSearchEmails = () => {
  const searchEmails = async (params, callback) => {
    const searchParam = {
      offset: params.offset,
      limit: params.limit,
      to: params.to,
      subject: params.subject,
      status: params.status,
      date: params.date,
    };

    try {
      const controller = new AbortController();
      const response = await axiosPrivate.get(LIST_QUERY, {
        params: searchParam,
        signal: controller.signal,
      });
      callback(response.data);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return searchEmails;
};

export const useDownloadAttachment = () => {
  const downloadAttachment = async (id, name, callback) => {
    const searchParam = {
      id: id,
    };
    try {
      const controller = new AbortController();
      const response = await axiosPrivate.get(GET_ATTACHMENT, {
        params: searchParam,
        signal: controller.signal,
        responseType: "blob",
      });
      fileDownload(response.data, name);
      callback(true);
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return downloadAttachment;
};

export const useLoadttachment = () => {
  const loadAttachment = async (id, callback) => {
    const searchParam = {
      id: id,
    };
    try {
      const controller = new AbortController();
      const response = await axiosPrivate.get(GET_ATTACHMENT, {
        params: searchParam,
        signal: controller.signal,
        responseType: "arraybuffer",
      });
      callback(Buffer.from(response.data, "binary").toString("base64"));
    } catch (err) {
      callback(err);
    }
  };

  const axiosPrivate = useAxiosPrivate();
  return loadAttachment;
};
